<template>
  <el-header class="sticky">
    <div class="nav">
      <!--logo-->
      <div v-if="screenWidth>1418" style="display: flex; align-items: center;max-width: 700px; flex: 2;">
        <img src="../assets/img/logo.png"
             width="60px" height="60px"
             @click="changeView('page')"
             :style="getStyle('logo')">
        <div v-if="screenWidth<1606" class="logo" style="line-height: 4px;">
          <p>检测鉴定人员技术培训</p>
          <p>在线学习系统</p>
        </div>
        <span v-else class="logo">检测鉴定人员技术培训在线学习系统</span>
      </div>

      <!--导航栏-->
      <el-menu :default-active="activeIndex"
               mode="horizontal"
               @select="changeView"
               text-color="white"
               active-text-color="#CCFFFF"
               :style="getStyle('menu')"
               id="eduMenu">
        <el-menu-item index="page">首页</el-menu-item>
        <el-menu-item index="trainList">技术人员培训学习</el-menu-item>
        <el-menu-item index="eduList">技术人员宣贯学习</el-menu-item>
        <!--<el-menu-item index="information">资讯</el-menu-item>-->
        <el-menu-item index="liveChannel">直播频道</el-menu-item>
        <el-menu-item index="mine">我的课程</el-menu-item>
        <el-menu-item index="help">帮助中心</el-menu-item>
      </el-menu>
      <!--搜索框-->
      <div style="display: flex; align-items: center;flex: 1">
        <el-select v-model="viewType" :style="getStyle('query')">
          <el-option label="技术人员培训学习" value="O"></el-option>
          <el-option label="技术人员宣贯学习" value="C"></el-option>
          <el-option label="帮助中心" value="H"></el-option>
          <!--<el-option label="资讯" value="I"></el-option>-->
        </el-select>
        <el-input :placeholder="viewType === 'I' ? '请输入资讯名称' : (viewType === 'H' ? '请输入问题' : '请输入课程名称')"
                  v-model="courseOrInfoName" clearable @clear="clearSearchVal(viewType)"></el-input>
        <el-button class="queryButton" id="queryButton" icon="el-icon-search"
                   @click="queryCourOrInfo(viewType)"></el-button>
      </div>


      <div v-if="!isLogin" :style="getStyle('login')">
        <el-button class="loginButton" type="primary" round @click="goToLogin()">登录</el-button>
      </div>

      <!--头像-->
      <div v-if="isLogin" class="head-image" :style="getStyle('login')">
        <img :src="!$store.state.userInfo.headImg ?  defaultCircleUrl : $store.state.userInfo.headImg"
             class="image"
             :onerror="failCircleUrl">
        <div class="head-info">
          <span class="head-name">{{ $store.state.userInfo.name }}</span>
          <div>
            <el-link :underline="false" @click="goToInfo('mine')">个人中心</el-link>
            <span style="margin: 0 5px">|</span>
            <el-link :underline="false" @click="changeView('loginOut')">退出</el-link>
          </div>
        </div>
      </div>

    </div>
  </el-header>
</template>

<script>
import Stickyfill from 'stickyfilljs';
import './../../public/static/js/tool';

export default {
  name: "EduHead",
  data() {
    return {
      defaultCircleUrl: require('@/assets/img/defaultAvatar.png'),
      failCircleUrl: 'this.src="' + require('@/assets/img/failAvatar.png') + '"' + ';this.onerror=null;',
      activeIndex: '',
      courseOrInfoName: '',
      viewType: 'O',
      isLogin: false,
      screenWidth: document.documentElement.clientWidth,
    };
  },
  watch: {
    $route: function () {
      this.changeIndex()
    }
  },
  methods: {
    changeIndex() {
      const path = this.$route.path;
      if (path.includes('page')) {
        this.activeIndex = 'page';
      } else if (path.includes('train')) {
        this.activeIndex = 'trainList';
      } else if (path.includes('edu')) {
        this.activeIndex = 'eduList';
      } else if (path.includes('information') || path.includes('article')) {
        this.activeIndex = 'information';
      } else if (path.includes('help')) {
        this.activeIndex = 'help';
      } else {
        this.activeIndex = '';
      }
    },
    queryCourOrInfo(viewType) {
      let routePath = ""
      switch (viewType) {
        case 'O':
          routePath = '/home/trainList';
          break;
        case 'C':
          routePath = '/home/eduList';
          break;
        case 'I':
          routePath = '/home/information';
          break;
        case 'H':
          routePath = '/home/help';
          break;
      }
      this.$router.push({path: routePath, query: {title: this.courseOrInfoName}});
      document.getElementById("queryButton").blur();
    },
    clearSearchVal(viewType) {
      this.queryCourOrInfo(viewType);
    },
    changeView(path) {
      if (path === 'loginOut') {
        this.loginOut();
        return
      }
      this.$router.push({path: '/home/' + path})
      let focusItem = document.querySelector('#eduMenu>li:focus');
      if (focusItem) focusItem.blur();
    },
    goToInfo(path) {
      this.$router.push({path: '/home/' + path, query: {title: '个人中心'}})
    },
    goToLogin() {
      // 判断是否在其他页面登录，是则刷新vuex
      this.$store.commit('refreshUser')
      if (this.$store.state.userInfo) {
        this.$router.go(0);
        return;
      }
      this.$router.push({path: '/login'});
    },
    loginOut() {
      let self = this;
      this.$confirm('是否退出登录?', "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async function () {
        const {success} = await self.$http.get('/system/web/user/loginOut');
        if (success) self.$store.commit('loginOut');
      }).catch(function () {
      });
    },
    getStyle(type) {
      if (this.isLogin) {
        switch (type) {
          case 'logo':
            return {
              cursor: 'pointer',
              marginLeft: this.screenWidth > 1418 ? String((this.screenWidth - 1190) * 0.03) + 'px' : '0px'
            }
            break;
          case 'menu':
            return {
              marginLeft: this.screenWidth > 1418 ? String((this.screenWidth - 1190) * 0.10) + 'px' : '64px',
              width: '516px'
            }
            break;
          case 'query':
            return {
              marginLeft: this.screenWidth > 1418 ? String((this.screenWidth - 1190) * 0.10) + 'px' : '60px'
            }
            break;
          case 'login':
            return {
              marginLeft: '20px',

            }
            break;
        }
      } else {
        switch (type) {
          case 'logo':
            return {
              cursor: 'pointer',
              marginLeft: this.screenWidth > 1418 ? String((this.screenWidth - 1190) * 0.05) + 'px' : '0px'
            }
            break;
          case 'menu':
            return {
              marginLeft: this.screenWidth > 1418 ? String((this.screenWidth - 1190) * 0.10) + 'px' : '117px',
              width: '516px'
            }
            break;
          case 'query':
            return {
              marginLeft: this.screenWidth > 1418 ? String((this.screenWidth - 1190) * 0.13) + 'px' : '50px'
            }
            break;
          case 'login':
            return {
              marginLeft: '20px',
              marginRight: '60px'
            }
            break;
        }
      }
    }
  },
  mounted() {
    this.changeIndex();

    this.screenWidth = document.documentElement.clientWidth;
    let _this = this;
    window.onresize = function () { // 定义窗口大小变更通知事件
      _this.screenWidth = document.documentElement.clientWidth; //窗口宽度
      _this.$store.commit('setScreenWidth', document.documentElement.clientWidth);
      // _this.$store.commit('setScreenHeight',document.documentElement.clientHeight);
    };

    // 判断是否登录
    const userInfo = this.$store.state.userInfo;
    if (userInfo) {
      this.isLogin = true;
    }

    //position:sticky,兼容IE浏览器
    //判断浏览器是否支持position:sticky
    if (!('CSS' in window && CSS.supports && CSS.supports('position', 'sticky'))) {
      var el = document.querySelectorAll('.sticky');
      Stickyfill.add(el);
    }
  }
}
</script>

<style lang="scss" scoped>
.sticky {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  left: 0;
  height: 92px !important;
  width: 100%;
  min-width: 1200px;
  z-index: 950;
  padding: 0;
  background: url("../assets/img/head-bg.jpg") no-repeat;
  background-size: cover;
  box-shadow: 0 4px 10px 0 hsla(240, 3%, 61%, .2);
}

.nav {
  color: white;
  font-size: 16px;
  display: flex;
  height: 92px;
  align-items: center;
  justify-content: space-between;

  .logo {
    margin-left: 10px;
    font-size: 24px;
    font-weight: bold;
  }

  .el-menu.el-menu--horizontal {
    border-bottom: none;
    background: none;
    flex: 2;

    .el-menu-item {
      height: 50px;
      line-height: 50px;
      padding: 0;
      margin-left: 20px;
      font-size: 16px;
      font-weight: bold;
      border-bottom: none;

      &:first-child {
        margin-left: 0;
      }

      &:hover {
        color: #CCFFFF !important;
        background: none !important;
        border-bottom: 2px solid #CCFFFF !important;
      }
    }
  }

  .el-menu--horizontal > .el-menu-item.is-active {
    border-bottom: 2px solid #CCFFFF !important;
    font-weight: 800;
  }

  .el-select {
    width: 158px;

    /deep/ .el-input__inner {
      border-radius: 20px 0 0 20px;
      border: none;
      background: white;
      color: #419AEA;
      text-align: center;
    }

    /deep/ .el-select__caret {
      color: #333333 !important;
    }
  }

  .el-input {
    width: 150px;

    /deep/ .el-input__inner {
      border-radius: 0;
      border: none;
      border-left: 1px solid #DCDFE6;
    }
  }

  .queryButton {
    height: 40px;
    border-radius: 0 20px 20px 0;
    border: none;
    padding: 11px 20px;
    font-size: 18px;

    &:hover {
      background: white;
    }
  }

  .loginButton {
    padding: 10px 20px;
    border: 1px solid white;
    background-color: #4992fb;
    /*&:hover{*/
    /*  font-weight: bold;*/
    /*  color: #ffffdc ;*/
    /*}*/
  }

  .head-image {
    display: flex;
    align-items: center;
    margin-right: 10px;

    .image {
      object-fit: cover;
      width: 60px;
      height: 60px;
      border-radius: 50%;
    }

    .head-info {
      display: flex;
      flex-flow: column;
      margin-left: 10px;

      .head-name {
        max-width: 100px;
        font-weight: 600;
        margin-bottom: 5px;
      }
    }

    .el-link.el-link--default {
      color: white;

      &:hover {
        color: #CCFFFF;
        font-weight: 600;
      }
    }
  }

}
</style>
